import { Checkbox } from "primereact/checkbox";
import React from "react";

import { generateFakeRows } from "../../common/components/fakeRows";
import IconLessButton from "../../images/icon_less_button.svg";
import IconServiceMore from "../../images/icon_service_more.svg";

export const VolanteAdditionalServicesTableAdmin = (props) => {
  const { searchAdditionalServices, tableFormGroup, estimateStatus } = props;

  const fakeRows = generateFakeRows(10);

  return (
    <table className="tableSearch" cellSpacing="0">
      <thead>
        <tr>
          <th
            style={{
              fontSize: 12,
              paddingLeft: "1rem",
              width: "10%",
            }}
            align="left"
          >
            <Checkbox
              disabled={estimateStatus === "PROCESSING"}
              className="check-box-table"
              checked={
                searchAdditionalServices.isSuccess &&
                tableFormGroup
                  .getFormGroup()
                  .get("services")
                  .value.filter((service) => service.info.checkable)
                  .map((service) => service.amount > 0)
                  .every((x) => x)
              }
              onChange={(e) => {
                if (e.checked) {
                  const servicesFG = tableFormGroup
                    .getFormGroup()
                    .get("services").controls;
                  servicesFG
                    .filter((serviceFG) => {
                      const info = serviceFG.get("info").value;
                      return info.checkable;
                    })
                    .filter((service) => {
                      return service.get("amount").value === 0;
                    })
                    .forEach((service) => {
                      service.get("amount").setValue(1);
                    });
                } else {
                  const servicesFG = tableFormGroup
                    .getFormGroup()
                    .get("services").controls;

                  servicesFG
                    .filter((serviceFG) => {
                      const info = serviceFG.get("info").value;
                      return info.checkable;
                    })
                    .filter((service) => {
                      return service.get("amount").value > 0;
                    })
                    .forEach((service) => {
                      service.get("amount").setValue(0);
                    });
                }
              }}
            />
          </th>
          <th className="th-size-color" style={{ width: "30%" }} align="left">
            <b>DESCRIPCIÓN</b>
          </th>
          <th className="th-size-color" style={{ width: "35%" }} align="center">
            <b>CÓDIGO SAP</b>
          </th>
          <th className="th-size-color" align="center" style={{ width: "25%" }}>
            <b>CANTIDAD</b>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody className="TableBody">
        <tr style={{ width: "100%", height: 8 }}></tr>
        {searchAdditionalServices.isLoading && <>{fakeRows}</>}
        {searchAdditionalServices.isSuccess && (
          <>
            {tableFormGroup.getFormGroup().get("services").controls.length ===
              0 && (
              <tr>
                <td colSpan={4}>NO HAY RESULTADOS</td>
              </tr>
            )}
            {tableFormGroup
              .getFormGroup()
              .get("services")
              .controls.map((fg) => {
                const formControlInfo = fg.get("info");
                const info = formControlInfo.value;
                const amount = fg.get("amount").value;

                return (
                  <React.Fragment key={info.sap_code}>
                    <tr
                      style={{ cursor: "pointer" }}
                      className="trBody"
                      onClick={() => {}}
                    >
                      <td style={{ paddingLeft: "1rem" }}>
                        {info.checkable && (
                          <Checkbox
                            disabled={estimateStatus === "PROCESSING"}
                            checked={fg.get("amount").value > 0}
                            onChange={(e) => {
                              if (e.checked) {
                                fg.get("amount").setValue(1);
                              } else {
                                fg.get("amount").setValue(0);
                              }
                            }}
                          ></Checkbox>
                        )}
                      </td>
                      <td align="left" onClick={() => {}}>
                        {info.service_name}
                      </td>
                      <td align="center" onClick={() => {}}>
                        {info.sap_code}
                      </td>
                      <td align="center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="button-style-table"
                            disabled={
                              amount < 1 || estimateStatus === "PROCESSING"
                            }
                            onClick={() => {
                              fg.get("amount").setValue(amount - 1);
                            }}
                          >
                            <img src={IconLessButton} alt="" />
                          </button>
                          <div
                            style={{
                              width: 36,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {amount}
                          </div>
                          <button
                            className="button-style-table"
                            style={{
                              background: `${
                                amount >= info.max_value ||
                                estimateStatus === "PROCESSING"
                                  ? "#002e6c8c"
                                  : "#002E6C"
                              }`,
                              color: "#FFFFFF",
                            }}
                            disabled={
                              amount >= info.max_value ||
                              estimateStatus === "PROCESSING"
                            }
                            onClick={() => {
                              const amount = fg.get("amount").value || 0;
                              fg.get("amount").setValue(amount + 1);
                            }}
                          >
                            <img
                              src={IconServiceMore}
                              alt=""
                              height="18px"
                              width="18px"
                            />
                          </button>
                        </div>
                      </td>
                      <td style={{ paddingRight: "1rem" }}>
                        {amount + info.amount}/{info.original_max_value}
                      </td>
                    </tr>
                    <tr style={{ width: "100%", height: 8 }}></tr>
                  </React.Fragment>
                );
              })}
          </>
        )}
        <tr style={{ height: 7 }}>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  );
};
